const baseURL = 'https://dev-info-image-demo.fox.ck.ua';

export const eStatementIsAvailableHTML = `<div style="max-width: 725px; font-size: 13px; line-height: 18px">
  <div>
    <p><img src="${baseURL}/guidance/email/images/logo.gif" alt="alt" style="margin-bottom: 15px" /></p>
  </div>
  <div>
    <p style="font-weight: bold; margin-bottom: 10px">Dear Carson Client,</p>
    <p style="margin-bottom: 10px">
      We're writing to let you know the July eStatement for your deposit account ending in 9999 is now available online.
    </p>
    <p style="margin-bottom: 10px">
      <a href="/guidance/statements/checking-statements" target="_blank" style="color: #4582ec; text-decoration: underline">
        View all of your paperless eStatements.
      </a>
    </p>
    <p style="margin-bottom: 10px">Please don't reply directly to this automatically-generated e-mail message.</p>
  </div>
  <div style="font-weight: bold; margin-bottom: 10px">Feel free to browse our other great offers:</div>
  <table cellpadding="0" cellspacing="0" border="0" style="width: 100%; border-collapse: collapse; margin-bottom: 10px">
    <tr>
      <td style="width: 33.33%; padding-right: 12px; vertical-align: top">
        <img src="${baseURL}/guidance/email/images/gif-small.gif" alt="alt" style="width: 100%; height: 150px; object-fit: cover; display: block; margin-bottom: 10px" />
        <p style="font-weight: bold; margin-bottom: 10px">Check out our loan rates as low as 5.59 APR!</p>
        <p style="margin-bottom: 10px">
          <a href="#" style="color: #4582ec; text-decoration: underline; margin-right: 5px">Apply online</a>
          or come visit our branch to learn about our great Auto Loan programs.
        </p>
      </td>
      <td style="width: 33.33%; padding: 0 12px; vertical-align: top">
        <img src="${baseURL}/guidance/email/images/home.jpeg" alt="alt" style="width: 100%; height: 150px; object-fit: cover; display: block; margin-bottom: 10px" />
        <p style="font-weight: bold; margin-bottom: 10px">Mortgages and Home Equity Loans approved in minutes!</p>
        <p style="margin-bottom: 10px">Call 1-866-278-3216 today.</p>
      </td>
      <td style="width: 33.33%; padding-left: 12px; vertical-align: top">
        <img src="${baseURL}/guidance/email/images/overdraft.jpeg" alt="alt" style="width: 100%; height: 150px; object-fit: cover; display: block; margin-bottom: 10px" />
        <p style="font-weight: bold; margin-bottom: 10px">Does your checking account have overdraft protection?</p>
        <p style="margin-bottom: 10px">Apply easily online here or speak to a teller at any branch.</p>
      </td>
    </tr>
  </table>
  <div style="border-top: 1px solid #888; padding-top: 10px; margin-bottom: 10px">
    <p style="margin-bottom: 10px">
      If you have received this email in error and are not the intended recipient, please reply to
      help@guidancefinancial.com to let us know. If you are the correct recipient, but would like to change your
      eStatement options, sign onto Account Manager and click on the "eStatements" tab.
    </p>
  </div>
</div>`;

export const emailVerificationHTML = `<p><img src="${baseURL}/guidance/email/images/logo.gif" alt="Logo" style="max-width: 300px; height: auto" /></p>
<p>Dear User,</p>
<p style="margin-bottom: 20px">
  Please <a href="#" style="color: #06c; text-decoration: underline">verify your email address</a> you just updated to
  your account.
</p>
<p style="margin-bottom: 20px">
  (If clicking the above link does not work, copy and paste it into your browser address bar)
</p>
<p style="margin-bottom: 20px">Thank you,</p>
<p style="margin-bottom: 20px">
  Data Center<br />InfoIMAGE Inc.<br />650.473.6388<br /><a href="mailto:data_center@infoimageinc.com"
    >data_center@infoimageinc.com</a
  >
</p>
<hr />
<p style="margin-top: 7px"><em>Please don't reply directly to this automatically-generated e-mail message.</em></p>
<hr />
<p style="margin-top: 10px">
  If you have received this email in error and are not the intended recipient, please reply to
  <a href="mailto:help@guidancefinancial.com">help@guidancefinancial.com</a> to let us know.
</p>
<p>
  If you are the correct recipient, but would like to change your eStatement options, sign onto Account Manager and
  click on the "eStatements" tab.
</p>`;

export const resetPasswordSecureTokenHTML = `<p><img src="${baseURL}/guidance/email/images/logo.gif" alt="Logo" style="max-width: 300px; height: auto" /></p>
<p style="font-weight: bold; margin-bottom: 20px">Dear User,</p>
<p style="margin-bottom: 20px">
  We're writing to let you know that your password reset token is available. Here is your secure token
  <strong>173506</strong>.
</p>
<p style="margin-bottom: 20px">Please don't reply directly to this automatically-generated e-mail message.</p>
<hr />
<p style="margin-top: 10px">
  If you have received this email in error and are not the intended recipient, please reply to
  help@guidancefinancial.com to let us know.
</p>
<p>
  If you are the correct recipient, but would like to change your eStatement options, sign onto Account Manager and
  click on the "eStatements" tab.
</p>`;

export const resetPasswordHTML = `<p><img src="${baseURL}/guidance/email/images/logo.gif" alt="Logo" style="max-width: 300px; height: auto" /></p>
<p>Dear User,</p>
<p>Please click the link below to reset your password:</p>
<p><a href="#" target="_blank" style="color: #06c; text-decoration: underline">https://infotrac.infoimageinc.com/urlValidation?uuid=fdc342-abcd-1234-dfr90-dfhdj90cf</a></p>
<p><br />Thank you</p>`;

export const visaApplicationHTML = `<p><img src="${baseURL}/guidance/email/images/logo.gif" alt="Logo" style="max-width: 300px; height: auto" /></p>
<p>Dear {{customerName}},</p>
<p style="margin-bottom: 20px">Thank you for your inquiry.</p>
<p>Best regards,<br />{{senderName}}</p>`;

export const noticeOfPastDuePaymentHTML = `<div style="font-size: 16px; font-family: 'Lato', 'Helvetica Neue', Arial, sans-serif; color: black; margin: 0; font-weight: 400;">
  <div style="padding: 20px 0;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px;">
      <img src="${baseURL}/guidance/email/logo.png" alt="Logo" style="max-width: 200px; height: auto;" />
    </div>
  </div>

  <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; border-bottom: 1px solid lightgray; padding-bottom: 40px;">
    <h1 style="background-color: #2D2E5E; font-family: 'Lato', sans-serif; font-weight: 700; color: white; font-size: 25px; padding: 20px; text-align: center; margin: 0 0 50px 0;">SECOND NOTICE OF PAST DUE LOAN</h1>

    <div style="border-right: 6px solid #2D2E5E; border-left: 6px solid #2D2E5E; padding: 10px 50px; font-size: 17px; border-radius: 5px; margin: 30px 0;">
      <div style="margin: 0;"><strong>Loan number ending in ******0925-0002</strong></div>
      <div style="margin-top: 7px;">Loan Description: <span style="color: #2D2E5E; font-weight: 700;">LINE OF CREDIT/OVERDRAFT</span></div>
      <div style="margin-top: 7px;">Payment Due Date: <span style="color: #2D2E5E; font-weight: 700;">09/11/24</span></div>
      <div style="margin-top: 7px;">Amount Due Now: <span style="color: #2D2E5E; font-weight: 700;">$436.39</span></div>
    </div>

    <div style="line-height: 1.5; padding: 0 20px;">
      <p style="margin: 30px 0;">Dear Member(s):</p>

      <p style="margin: 30px 0;">Your LINE OF CREDIT/OVERDRAFT loan payment of $436.39 was due on 09/11/24 and is currently 22 days past due. The total amount past due is $436.39, which includes a late charge of $10.00. If you have already made your payment, please disregard this notice.</p>

      <p style="margin: 30px 0;">If you're experiencing financial challenges, we want to help. Please call us today to learn which of the available options, such as a loan deferment, temporary loan modification, or permanent loan modification, may be right for you.</p>

      <p style="margin: 30px 0;">In addition, GFI offers financial counseling as a Member benefit through our partners at BALANCE. Their experts can help you with debt management, credit issues, and repossession or foreclosure prevention. To contact BALANCE, please call 1 (888) 456-2227 or visit www.balancepro.org.</p>

      <p style="margin: 30px 0;">To make arrangements for the past due amount, or discuss options available to you, please contact us at 1 (866) 479-2800. We value your relationship with us and appreciate your timely attention to this matter.</p>

      <p style="margin: 30px 0;">Thank you,<br>Financial Assistance Team</p>

      <p style="margin: 30px 0;"><em style="font-style: italic;">We are required to report information about your account to credit bureaus. Late payments, missed payments, or other defaults on your account may be reflected in your credit report. If you have a GFI debit card or digital banking, we may turn off your access to these services if your loan becomes 25 days past due or more.</em></p>
    </div>
  </div>

  <div style="padding: 20px 0 40px;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; display: flex; flex-wrap: wrap; justify-content: center;">
      <a href="tel:1 (800) 555-0100" style="font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center;">
        <img src="${baseURL}/guidance/email/phone.png" alt="phone image" style="height: 23px; margin-right: 5px; display: inline-block;"><span>1 (800) 555-0100</span>
      </a>
      <a href="https://www.guidance.com/" style="font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center; margin-left: 30px;">
        <img src="${baseURL}/guidance/email/web.png" alt="site image" style="height: 18px; margin-right: 7px; display: inline-block;"><span>guidance.com</span>
      </a>
    </div>
  </div>
</div>`;

export const atmNoticeHTML = `<div style="font-size: 16px; font-family: 'Lato', 'Helvetica Neue', Arial, sans-serif; color: black; margin: 0; font-weight: 400;">
  <div style="padding: 20px 0;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px;">
      <img src="${baseURL}/guidance/email/logo.png" alt="Logo" style="max-width: 200px; height: auto;" />
    </div>
  </div>

  <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; border-bottom: 1px solid lightgray; padding-bottom: 40px;">
    <h1 style="background-color: #2D2E5E; font-family: 'Lato', sans-serif; font-weight: 700; color: white; font-size: 25px; padding: 20px; text-align: center; margin: 0 0 50px 0;">ATM DEPOSIT NOTICE OF HOLD</h1>

    <div style="border-right: 6px solid #2D2E5E; border-left: 6px solid #2D2E5E; padding: 10px 50px; font-size: 17px; border-radius: 5px; margin: 30px 0;">
      <div style="margin: 0;">Member Number: <span style="color: #2D2E5E; font-weight: 700;">XXXXXX7372*</span></div>
      <div style="margin-top: 7px;">Account Type: <span style="color: #2D2E5E; font-weight: 700;">CHECKING</span></div>
      <div style="margin-top: 7px;">Deposit Date: <span style="color: #2D2E5E; font-weight: 700;">10/02/2024</span></div>
      <span style="font-size: 13px; margin-top: 7px; display: inline-block;">*For the security of your account, your Member number has been truncated to the last 4 digits.</span>
    </div>

    <h4 style="font-size: 19px; font-weight: 700; margin: 30px 0;">Guidance is delaying the availability of your ATM deposit as follows:</h4>

    <div style="border-right: 6px solid #2D2E5E; border-left: 6px solid #2D2E5E; padding: 15px 50px; border-radius: 5px; margin: 30px 0;">
      <div style="margin: 0;">Deposit amount: <strong>$564.28</strong></div>
      <div style="margin-top: 5px;">Amount being held: <strong>$564.28</strong></div>
      <div style="margin-top: 5px;">Funds will be available on: <strong>10/09/24</strong></div>
    </div>

    <h4 style="font-size: 19px; font-weight: 700; margin: 30px 0; text-align: center;">The reason for the delay is explained below:</h4>

    <div style="border-right: 6px solid #2D2E5E; border-left: 6px solid #2D2E5E; padding: 15px 50px; border-radius: 5px; margin: 30px 0;">
      <h2 style="margin: 0; font-size: 20px;">NEW MEMBERSHIP ACCOUNT</h2>
    </div>

    <div style="line-height: 1.5; padding: 0 20px;">
      <p style="margin: 30px 0;">If you did not receive this notice at the time you made the deposit and the check you deposited is paid, we will reimburse to you any non-sufficient fund (NSF) or overdraft fees that result solely from the hold placed on your deposit. To obtain a reimbursement of such fees, write to us within 60 days of receipt of the account statement which shows that fee, at the address below. If you have any questions, please call us at 1 (800) 555-0100.</p>

      <p style="margin: 30px 0;">Thank you for allowing Guidance to serve your financial needs.</p>

      <p style="margin: 30px 0;">Best regards,<br>
        Electronic Services<br>
        Guidance
      </p>
    </div>
  </div>

  <div style="padding: 20px 0 40px;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; display: flex; flex-wrap: wrap; justify-content: center;">
      <a href="tel:1 (800) 555-0100" style="font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center;">
        <img src="${baseURL}/guidance/email/phone.png" alt="phone image" style="height: 23px; margin-right: 5px; display: inline-block;"><span>1 (800) 555-0100</span>
      </a>
      <a href="https://www.guidance.com/" style="font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center; margin-left: 30px;">
        <img src="${baseURL}/guidance/email/web.png" alt="site image" style="height: 18px; margin-right: 7px; display: inline-block;"><span>guidance.com</span>
      </a>
    </div>
  </div>
</div>`;

export const overDraftNoticeHTML = `<div style="font-size: 16px; font-family: 'Lato', 'Helvetica Neue', Arial, sans-serif; color: black; margin: 0; font-weight: 400;">
  <div style="padding: 20px 0;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px;">
      <img src="${baseURL}/guidance/email/logo.png" alt="Logo" style="max-width: 200px; height: auto;" />
    </div>
  </div>

  <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; border-bottom: 1px solid lightgray; padding-bottom: 40px;">
    <h1 style="background-color: #2D2E5E; font-family: 'Lato', sans-serif; font-weight: 700; color: white; font-size: 25px; padding: 20px; text-align: center; margin: 0 0 50px 0;">NON-SUFFICIENT FUNDS NOTICE</h1>

    <div style="border-right: 6px solid #2D2E5E; border-left: 6px solid #2D2E5E; padding: 10px 50px; font-size: 17px; border-radius: 5px; margin: 30px 0;">
      <div style="margin: 0;">Member Number: <span style="color: #2D2E5E; font-weight: 700;">XXXXXX7033-10</span></div>
    </div>

    <div style="line-height: 1.5; padding: 0 20px;">
      <p style="margin: 30px 0;">Dear KALIL & SON CONSTRUCTION & REMODELING:<br>
        The following item(s) recently presented for payment exceeded your available funds at the time:
      </p>

      <table border="1" cellspacing="0" cellpadding="10" style="width: 100%;">
        <thead>
          <tr>
            <th style="text-align: center;">Item Description</th>
            <th style="text-align: center;">Amount of Item</th>
            <th style="text-align: center;">Paid or Returned</th>
            <th style="text-align: center;">Fee Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">VERIZON WIRELESS</td>
            <td style="text-align: center;">$446.46</td>
            <td style="text-align: center;">Returned</td>
            <td style="text-align: center;">$9</td>
          </tr>
        </tbody>
      </table>

      <p style="margin: 30px 0;">Charges totaling $9.00 have been deducted from your account, and any applicable fees have been assessed.
        Please make a deposit or transfer immediately to bring your account to a positive balance.</p>

      <p style="margin: 30px 0;">To avoid non-sufficient funds (NSF) fees in the future, consider these other options:</p>

      <ul style="margin: 30px 0; padding-left: 20px;">
        <li style="margin-top: 10px;"><strong>Overdraft Account Transfer:</strong> Funds will automatically be transferred on your behalf
          from your other GFI accounts to this account in $100 increments to cover the transaction with no fee.</li>
        <li style="margin-top: 10px;"><strong>Overdraft Line of Credit:</strong> Funds will automatically be advanced and transferred on
          your behalf from your line of credit in $100 increments to this account to cover the transaction.
          Because this is a loan, daily interest will be charged on the balance. Visit guidance.com/loans to learn more.</li>
        <li style="margin-top: 10px;"><strong>Text or Email Alerts:</strong> Monitor your account balance by setting up alerts. Log in to
          your mobile app or online banking to see your options.</li>
        <li style="margin-top: 10px;"><strong>BALANCE Financial Fitness:</strong> As a Member benefit, our partners at BALANCE can help
          you with budgeting, credit counseling, and more. Please visit balancepro.org or call 1 (888) 456-2227.</li>
      </ul>

      <p style="margin: 30px 0;">To view your accounts in real time, make transfers, or if you have any questions, please log in to your
        GFI mobile app or online banking or contact us at 1 (800) 555-0100. We value your relationship with us
        and are here to help you on your financial journey.</p>

      <p style="margin: 30px 0;">Best Regards,<br>
        Guidance
      </p>

      <p style="margin: 30px 0;"><em style="font-style: italic;">
        GFI's current NSF fee of $9 may be charged to your account for each NSF transaction. This fee is in
        addition to any fee that may be assessed by a third party.
      </em></p>
    </div>
  </div>

  <div style="padding: 20px 0 40px;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; display: flex; flex-wrap: wrap; justify-content: center;">
      <a href="tel:1 (800) 555-0100" style="font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center;">
        <img src="${baseURL}/guidance/email/phone.png" alt="phone image" style="height: 23px; margin-right: 5px; display: inline-block;"><span>1 (800) 555-0100</span>
      </a>
      <a href="https://www.guidance.com/" style="font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center; margin-left: 30px;">
        <img src="${baseURL}/guidance/email/web.png" alt="site image" style="height: 18px; margin-right: 7px; display: inline-block;"><span>guidance.com</span>
      </a>
    </div>
  </div>
</div>`;

export const overDraftPayAdvantageHTML = `<div style="font-size: 16px; font-family: 'Lato', 'Helvetica Neue', Arial, sans-serif; color: black; margin: 0; font-weight: 400;">
  <div style="padding: 20px 0;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px;">
      <img src="${baseURL}/guidance/email/logo.png" alt="Logo" style="max-width: 200px; height: auto;" />
    </div>
  </div>

  <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; border-bottom: 1px solid lightgray; padding-bottom: 40px;">
    <h1 style="background-color: #2D2E5E; font-family: 'Lato', sans-serif; font-weight: 700; color: white; font-size: 25px; padding: 20px; text-align: center; margin: 0 0 50px 0;">OVERDRAFT PAY ADVANTAGE AND/OR NON-SUFFICIENT FUNDS NOTICE</h1>

    <div style="border-right: 6px solid #2D2E5E; border-left: 6px solid #2D2E5E; padding: 10px 50px; font-size: 17px; border-radius: 5px; margin: 30px 0;">
      <div style="margin: 0;">Member Number: <span style="color: #2D2E5E; font-weight: 700;">XXXXXX1759-10</span></div>
    </div>

    <div style="line-height: 1.5; padding: 0 20px;">
      <p style="margin: 30px 0;">Dear JANELLE TAYLOR:<br>
        The following item(s) recently presented for payment exceeded your available funds at the time:
      </p>

      <table border="1" cellspacing="0" cellpadding="10" style="width: 100%; font-size: 12px;">
        <thead>
          <tr>
            <th style="text-align: center;">Item Description</th>
            <th style="text-align: center;">Amount of Item</th>
            <th style="text-align: center;">Paid or Returned</th>
            <th style="text-align: center;">Fee Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="text-align: center;">DD*DOORDASH MCDONALDS WWW.DOORDASH.CA</td>
            <td style="text-align: center;">$18.17</td>
            <td style="text-align: center;">Paid</td>
            <td style="text-align: center;">$0</td>
          </tr>
          <tr>
            <td style="text-align: center;">CSC SERVICEWORK ROHNERT PARK CA</td>
            <td style="text-align: center;">$2.50</td>
            <td style="text-align: center;">Paid</td>
            <td style="text-align: center;">$0</td>
          </tr>
        </tbody>
      </table>

      <p style="margin: 30px 0;">Your current Overdraft Pay Advantage (OPA) limit is $1,500.00. Based on your relationship with us, we
        will provide a courtesy pay for overdrafts on your everyday debit card transactions, checks, and
        automatic bill payments (including automated payments and recurring debit transactions). We will
        generally pay overdrafts up to the limit previously disclosed to you if your accounts are in good
        standing. If your account is not in good standing, is continuously negative for more than 20 days, you
        have a loan with us that is more than 10 days delinquent, you have not made regular deposits into your account, or
        you are otherwise in breach of any of your agreements with GFI, we may not be able to pay your
        transaction.</p>

      <p style="margin: 30px 0;">To view your OPA limit, please log in to your account. Each time you use Overdraft Pay Advantage, you
        will be charged a $19 fee which will debit from your account in addition to any paid items. If you have
        non-sufficient funds (NSF), you will be charged a $9 fee, which will debit from your account. Once an
        overdraft is paid, we ask that you make a deposit to cover the negative balance in your account
        immediately, and no later than 10 days after the overdraft occurs. You can update your OPA settings
        anytime by logging into your account, by calling us, or visiting a branch.
      </p>

      <p style="margin: 30px 0;">Fee charges totaling $0.00 have been deducted from your account. Please make a deposit or transfer
        immediately to bring your account to a positive balance. Your balance has been adjusted by the items
        paid and fees assessed. Failure to bring your account to a positive balance within 20 days may result in
        suspension from the program, and your account may be closed and reported for collection.
      </p>

      <p style="margin: 30px 0;">If you have any questions, please log in to your account to send us a secure message or contact us at 1
        (800) 555-0100. To learn how to prevent overdrafts, please visit guidance.com/overdraft-protection. We
        value your relationship with us and are here to help you on your financial journey.
      </p>

      <p style="margin: 30px 0;">Best Regards,<br>
        Guidance
      </p>

      <p style="margin: 30px 0;"><em style="font-style: italic;">
        Please note that GFI's current NSF fee of $9 may be charged to your account for each NSF transaction.
        This fee is in addition to any fee that may be assessed by a third party.
      </em></p>
    </div>
  </div>

  <div style="padding: 20px 0 40px;">
    <div style="max-width: 984px; margin: 0 auto; padding: 0 20px; display: flex; flex-wrap: wrap; justify-content: center;">
      <a href="tel:1 (800) 555-0100" style="font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center;">
        <img src="${baseURL}/guidance/email/phone.png" alt="phone image" style="height: 23px; margin-right: 5px; display: inline-block;"><span>1 (800) 555-0100</span>
      </a>
      <a href="https://www.guidance.com/" style="margin-left: 30px; font-size: 18px; color: black; text-decoration: none; display: flex; align-items: center;">
        <img src="${baseURL}/guidance/email/web.png" alt="site image" style="height: 18px; margin-right: 7px; display: inline-block;"><span>guidance.com</span>
      </a>
    </div>
  </div>
</div>`;
